export default "__VITE_ASSET__36827b49__"